module.exports = __webpack_public_path__ + "static/img/6areaA_10.ffd9ff3.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/ワンダー系/6areaA_10.png
// module id = 954
// module chunks = 1